import { useMemo } from "react"
import { Boost } from "@mezo/api"
import { SupportedTokenName } from "@mezo/sdk"
import { Block, LabelSmall, useStyletron } from "@mezo-org/mezo-clay"

import { separateThousandsWithComaRegExp } from "#/shared/utils"

import { TokenIcon } from "../Token"

type DepositStablecoinBoostProps = {
  dailyBoostMats: Boost[]
}

export default function DepositStablecoinBoost({
  dailyBoostMats,
}: DepositStablecoinBoostProps) {
  const [css, theme] = useStyletron()

  const totalStablecoinBoost = useMemo(
    () => dailyBoostMats.reduce((prev, curr) => prev + Number(curr.value), 0),
    [dailyBoostMats],
  )

  const shouldDisplayStablecoinBoost = dailyBoostMats.length > 0

  return (
    <Block height="16px">
      {shouldDisplayStablecoinBoost && (
        <Block
          className={css({
            display: "flex",
            alignItems: "center",
            gap: theme.sizing.scale100,
          })}
        >
          <Block
            className={css({
              display: "flex",
              alignItems: "center",
              gap: theme.sizing.scale100,
            })}
          >
            {dailyBoostMats.map((stablecoin, index) => (
              <Block
                key={stablecoin.token}
                className={css({
                  zIndex: index + 1,
                  position: "relative",
                  marginLeft: index > 0 ? `-${theme.sizing.scale200}` : 0,
                })}
              >
                <TokenIcon
                  token={stablecoin.token as SupportedTokenName}
                  size={theme.sizing.scale600}
                />
              </Block>
            ))}
          </Block>
          <LabelSmall>
            {separateThousandsWithComaRegExp(totalStablecoinBoost.toString())}
          </LabelSmall>
        </Block>
      )}
    </Block>
  )
}
